import type { BaseItem } from '~/models/Content/BaseItem'
import type { LabelField } from '~/models/Content/BaseField'
import { useI18n } from 'vue-i18n'

export default () => {
  const { t } = useI18n()

  const getDescriptor = (content: BaseItem): string => {
    const { chapterNumber, labelField } = content

    if (chapterNumber)
      return `${t(`labels.chapter`)} ${chapterNumber}`
    if (labelField && content[labelField])
      return translateValue(labelField, content[labelField])
    if (content.activity)
      return translateValue('activity', content.activity)
    if (content.genre)
      return translateValue('genre', content.genre)
    if (content.label)
      return translateValue('label', content.label)
    return t(`contentTypes.${content.contentTypeIdentifier}`)
  }

  const translateValue = (field: LabelField, value: string) => {
    if (field === 'activity')
      return t(`activities.${value}`.toLowerCase(), value)
    if (field === 'genre')
      return t(`genre.${value}`.toLowerCase(), value)
    if (field === 'label')
      return t(`labels.${value}`, '')
    return ''
  }

  return {
    getDescriptor,
  }
}
